/* Feature Reel - pauses autoplaying video once a card scrolls out of view. */
(function () {
  'use strict';
  function init(scope) {
    var reels = (scope || document).querySelectorAll('.hp-reel');
    [].slice.call(reels).forEach(function (reel) {
      if (reel.hpReelVideo) return;
      reel.hpReelVideo = true;
      var vids = [].slice.call(reel.querySelectorAll('video[data-reel-autoplay="true"]'));
      if (!vids.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { io.observe(v); });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) return;
        vids.forEach(function (v) { v.pause(); });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
